import UnauthorizedError from "./unauthorized.js";

export default class BlockedError extends UnauthorizedError {
  constructor() {
    super("Blocked");
  }
}